import { Close } from "@material-ui/icons";
import React, { useState } from "react";
import SideNav from "../SideNav/SideNav";
import { SettingsType } from "../Write";
import Tab1 from "./SettingsTabs/Tab1/Tab1";
import "./Settings.scss";
import Tab2 from "./SettingsTabs/Tab2/Tab2";
import Tab3 from "./SettingsTabs/Tab3/Tab3";
import ReactGA from "react-ga";

type Props = {
    values: SettingsType;
    dismissible: boolean;
    setValues: (arg: SettingsType) => void;
    goToScrapbook: () => void;
};

const Settings: React.FC<Props> = (props) => {
    const [showScrap, setShowScrap] = useState(true);
    const [menu, setMenu] = useState(0);

    function toggleScrapVisible() {
        setShowScrap(!showScrap);
    }

    return (
        <div className="settings_section">
            <div className="header">
                <p>
                    <b>Story Settings</b>
                </p>
                <div className="tabbar-view">
                    <div
                        className={`tab ${menu == 0 ? "active" : ""}`}
                        onClick={() => {
                            ReactGA.event({
                                category: "Write Story",
                                action: "Story details filling",
                            });
                            setMenu(0);
                        }}
                    >
                        Story Details
                    </div>
                    <div
                        className={`tab ${menu == 1 ? "active" : ""}`}
                        onClick={() => {
                            ReactGA.event({
                                category: "Write Story",
                                action: "Protagonist details filling",
                            });
                            setMenu(1);
                        }}
                    >
                        Protagonist Details
                    </div>
                    <div
                        className={`tab ${menu == 2 ? "active" : ""}`}
                        onClick={() => {
                            ReactGA.event({
                                category: "Write Story",
                                action: "Story outcome filling",
                            });
                            setMenu(2);
                        }}
                    >
                        Story Outcome
                    </div>
                    <div
                        className="tab-indicator"
                        style={{ transform: `translateX(${menu * 146}px)` }}
                    ></div>
                </div>
                <button
                    className="icon_button"
                    onClick={props.goToScrapbook}
                    disabled={!props.dismissible}
                >
                    <Close style={{ pointerEvents: "none" }} />
                </button>
            </div>
            <div className="settings_body">
                {!showScrap && (
                    <button
                        className="open_scrap_btn"
                        onClick={toggleScrapVisible}
                    >
                        Open Scrapbook
                    </button>
                )}
                <SideNav show={showScrap} toggle={toggleScrapVisible} />
                {menu === 0 && (
                    <Tab1 values={props.values} setValues={props.setValues} />
                )}
                {menu === 1 && (
                    <Tab2 values={props.values} setValues={props.setValues} />
                )}
                {menu === 2 && (
                    <Tab3 values={props.values} setValues={props.setValues} />
                )}
            </div>
        </div>
    );
};

export default Settings;
